import { render, staticRenderFns } from "./CShimmer.vue?vue&type=template&id=d9c98b8c&"
import script from "./CShimmer.vue?vue&type=script&lang=ts&"
export * from "./CShimmer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports